import { CurrentToolUsage, GetToolUsageResponse, useGetCurrentUserQuery, useIsOwnerQuery } from "@/store/services/supabase";
import ArrowRightOutlined from "@ant-design/icons/es/icons/ArrowRightOutlined";
import * as Sentry from "@sentry/nextjs";
import { Alert, Button } from "antd";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
const DetailsButton = () => <Link href="/settings/org/usage" target="_blank" rel="noreferrer" data-sentry-element="Link" data-sentry-component="DetailsButton" data-sentry-source-file="ScreeningFairUseWarning.tsx">
    <Button size="small" type="text" data-sentry-element="Button" data-sentry-source-file="ScreeningFairUseWarning.tsx">
      Details {<ArrowRightOutlined />}
    </Button>
  </Link>;
const ScreeningFairUseWarning = ({
  toolUsage,
  currentUsage,
  hideDetail = false
}: {
  toolUsage: GetToolUsageResponse;
  currentUsage: CurrentToolUsage;
  hideDetail?: boolean;
}) => {
  const {
    data: isOwner,
    isFetching,
    isLoading,
    isSuccess
  } = useIsOwnerQuery();
  const {
    data: currentUser
  } = useGetCurrentUserQuery();
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "screening.uploadLimitAlert"
  });

  // Do not show if in process of loading data.
  if (isFetching || isLoading) {
    return <></>;
  }
  if (!currentUsage || typeof currentUsage.quota !== "number" || currentUsage.quota === 0) {
    Sentry.captureException("screeningFairUseWarning", {
      tags: {
        section: "Quota Limit Error"
      },
      extra: {
        userId: currentUser?.id,
        orgId: currentUser?.org_id,
        toolUsage,
        currentUsage
      }
    });
    return <Alert type="error" className="mb-4" showIcon message={<Markdown>{isOwner ? t("owner.refresh") : t("user.refresh")}</Markdown>} />;
  }
  return <>
      {isSuccess && currentUsage.showWarning === "warn" && <Alert type="warning" className="mb-4" showIcon action={!hideDetail && isOwner && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.warning") : t("user.warning")}</Markdown>} />}

      {isSuccess && currentUsage.showWarning === "error" && <Alert type="error" className="mb-4" showIcon action={!hideDetail && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.error") : t("user.error")}</Markdown>} />}
    </>;
};
export default ScreeningFairUseWarning;